import { lazy } from "react";

/* React.lazy for a named export. If the chunk can't load (usually a deploy
   replaced the file names while the page was open), reload once to pick up
   the new build instead of leaving a blank screen. The timestamp guard stops
   a reload loop when the network is simply down. */

const KEY = "theweb.chunkReload.v1";

function reloadOnce(err) {
  // Only a missing chunk is cured by a reload. A module that throws is a bug,
  // and offline a reload would land on the browser's error page.
  const missingChunk = err?.name === "ChunkLoadError" || /Loading (CSS )?chunk/.test(err?.message || "");
  if (!missingChunk || navigator.onLine === false) throw err;
  let last = 0;
  try { last = Number(sessionStorage.getItem(KEY)) || 0; } catch (e) { /* storage unavailable */ }
  if (Date.now() - last > 30000) {
    try { sessionStorage.setItem(KEY, String(Date.now())); } catch (e) { /* storage unavailable */ }
    window.location.reload();
    return new Promise(() => {});
  }
  throw err;
}

export function lazyNamed(load, name) {
  return lazy(() => load().then((m) => ({ default: m[name] }), reloadOnce));
}
